import r from"react";var e=function(t){return Array.isArray(t)?t.some((function(r){return e(r)})):!!r.isValidElement(t)&&(!!Object.hasOwn(t.props,"href")||e(t.props.children))};export{e as default};
